/** Local formatters not in the kit — dashboard-specific. */

export function formatTier(tier: string): { label: string; color: string } {
  switch (tier) {
    case 'strong_growth':   return { label: 'Strong Growth',   color: 'var(--color-positive)' };
    case 'moderate_growth': return { label: 'Moderate Growth', color: 'var(--color-teal)'    };
    case 'flat':            return { label: 'Flat',            color: 'var(--color-neutral)' };
    case 'declining':       return { label: 'Declining',       color: 'var(--color-negative)'};
    default:                return { label: tier,              color: 'var(--color-neutral)' };
  }
}

export function fmtShare(v: number, digits = 1): string {
  if (!Number.isFinite(v)) return '—';
  return `${(v * 100).toFixed(digits)}%`;
}

export function fmtInt(v: number): string {
  if (!Number.isFinite(v)) return '—';
  return Math.round(v).toLocaleString('en-PH');
}
